import { useTranslation } from "react-i18next";
import { setAppLanguage } from "@/i18n";

export function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "it";
  return (
    <div className={`inline-flex items-center rounded-full border border-slate-200 bg-white/80 p-0.5 text-xs ${className}`} data-testid="language-switcher">
      <button
        type="button"
        onClick={() => setAppLanguage("it")}
        className={`rounded-full px-2.5 py-1 font-semibold tracking-wide transition ${current === "it" ? "bg-blue-900 text-white" : "text-slate-500 hover:text-blue-900"}`}
        data-testid="lang-it-button"
      >
        IT
      </button>
      <button
        type="button"
        onClick={() => setAppLanguage("en")}
        className={`rounded-full px-2.5 py-1 font-semibold tracking-wide transition ${current === "en" ? "bg-blue-900 text-white" : "text-slate-500 hover:text-blue-900"}`}
        data-testid="lang-en-button"
      >
        EN
      </button>
    </div>
  );
}
